import { render } from "./offer.vue?vue&type=template&id=5d885a7a&scoped=true"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"

import "./offer.vue?vue&type=style&index=0&id=5d885a7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d885a7a"

export default script